import { useSelector } from 'react-redux';
import { carePhaseDefs, SessionType } from '@shared';
import { selectClient, selectSessionAdvisor, selectSession } from '@client/model';
import {
  normalizePoliciesForComparison,
  mergeSameCarrierPolicies,
} from '@/features/policies-comparison';
import { useFeatureFlags } from '@client/contexts/FeatureFlagsContext';

export function usePoliciesComparison() {
  const { flags } = useFeatureFlags();
  const client = useSelector(selectClient);
  const advisor = useSelector(selectSessionAdvisor);
  const session = useSelector(selectSession);

  const ltcPolicies = client.multipleFundingSources.ltcPolicy;
  const normalized = normalizePoliciesForComparison(ltcPolicies, client);
  const data = mergeSameCarrierPolicies(normalized);

  const clientHasStartedLtc = client?.intakeSurvey?.clientHasStartedLtc;
  const clientCurrentCarePhase = client?.intakeSurvey?.clientCurrentCarePhase;
  const ltcAtAge = client?.appliedInferenceSet?.ltcAtAge;

  const inflatedBenefitLabel =
    clientHasStartedLtc && clientCurrentCarePhase
      ? `At ${carePhaseDefs[clientCurrentCarePhase].label} Phase`
      : ltcAtAge
        ? `At LTC start (age ${ltcAtAge})`
        : 'At LTC start';

  const clientName = [client.clientFirstName, client.clientLastName].filter(Boolean).join(' ');
  const advisorName = [advisor?.advisorFirstName, advisor?.advisorLastName]
    .filter(Boolean)
    .join(' ');
  const organizationName = advisor?.organizationDisplayName || advisor?.organizationName;
  const isAdvisor =
    session.sessionType === SessionType.advisor || session.sessionType === SessionType.wizard;

  return {
    clientId: client.clientId,
    clientName,
    advisorName,
    organizationName,
    data,
    flags,
    inflatedBenefitLabel,
    isAdvisor,
  };
}
